import { useEffect, useState } from 'react';
import type { Loadable } from 'recoil';

type ResolvedItems<T> = {
    accountId: string,
    items: readonly T[],
};

export const useResolvedDropdownItems = <T>(accountId: string, itemsLoadable: Loadable<readonly T[]>): readonly T[] => {
    const [resolvedItems, setResolvedItems] = useState<ResolvedItems<T>>({
        accountId,
        items: [],
    });

    useEffect(() => {
        if (itemsLoadable.state === 'hasValue') {
            setResolvedItems({
                accountId,
                items: itemsLoadable.contents,
            });
        }
    }, [accountId, itemsLoadable.contents, itemsLoadable.state]);

    return itemsLoadable.state === 'hasValue'
        ? itemsLoadable.contents
        : resolvedItems.accountId === accountId
            ? resolvedItems.items
            : [];
};
